<template>
  <div class="grid">
    <Header />
    <div class="contents">
      <router-view />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from './components/layout/Header.vue';
import Footer from './components/layout/Footer.vue';
export default {
  components: {
    Header,
    Footer,
  },
  mounted() {
    console.log('availableProducts', window.availableProducts);
  },
};
</script>

<style>
.p-datepicker-year {
  border: 0px !important;
}
.p-datepicker-month {
  border: 0px !important;
}

.output-textArea {
  width: 300px !important;
}
</style>
